var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-modal',{attrs:{"id":_vm.id,"header-class":"my-class","hide-footer":"","size":"xl"},scopedSlots:_vm._u([{key:"modal-title",fn:function(){return [_vm._t("title")]},proxy:true},{key:"default",fn:function(){return [_vm._t("body")]},proxy:true}],null,true)})
}
var staticRenderFns = []

export { render, staticRenderFns }